// Language translations for Bible Buds
export const translations = {
  en: {
    // Common
    app_name: "Bible Buds",
    loading: "Loading...",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    open: "Open",
    close: "Close",
    retry: "Try Again",
    done: "done",
    
    // Auth
    welcome: "Welcome to Bible Buds!",
    login: "Login",
    parent_login: "Parent Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    forgot_password: "Forgot password?",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    login_btn: "Login",
    register_btn: "Create Account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    select_language: "Select Language",
    start_free_trial: "Start free trial!",
    parent_sign_in: "Parent Sign In",
    im_a_kid: "I'm a Kid!",
    parents_sign_first: "Parents must sign in first on this device",
    need_help: "Need help?",
    create_secure_password: "Create a secure password",
    email_placeholder: "parent@email.com",
    your_full_name: "Your full name",
    choose_plan: "Choose Your Plan",
    monthly_plan: "Monthly Plan",
    annual_plan: "Annual Plan",
    free_trial_then: "7-day free trial, then billed",
    save_percent: "Save",
    per_month: "/month",
    per_year: "/year",
    
    // Landing
    hero_title: "Daily Bible Lessons for Kids!",
    hero_subtitle: "Fun, age-appropriate Bible lessons and activities for your children",
    get_started: "Get Started",
    church_login: "Church Login",
    kids_login: "Kids Login",
    
    // Parent Dashboard
    parent_dashboard: "Parent Dashboard",
    welcome_back: "Welcome back",
    family_doing: "Here's how your family is doing today.",
    your_children: "Your Children",
    add_child: "Add Child",
    add_first_child: "Add your first child!",
    setup_profile: "Set up a profile to start their Bible journey.",
    children: "Children",
    today_lessons: "Today's Lessons",
    total_lessons: "Total Lessons",
    stars_earned: "Stars Earned",
    lesson_history: "Lesson History",
    track_progress: "Track progress",
    reminders_on: "Reminders On",
    reminders_off: "Reminders Off",
    daily_reminder: "Daily 10 AM",
    tap_enable: "Tap to enable",
    weekly_email_on: "Weekly Email: On",
    weekly_email_off: "Weekly Email: Off",
    weekly_email_desc: "Receive a Sunday summary of your family's progress",
    verse_practice: "Verse Practice Game",
    practice_memorize: "Play fun games to memorize this week's verse!",
    play: "Play",
    view_all: "View",
    logout: "Logout",
    prize: "Prize",
    del: "Del",
    confirm_remove_child: "Remove this child profile?",
    could_not_delete: "Could not delete.",
    reset_today_lesson: "Reset Today's Lesson",
    confirm_reset_lesson: "Are you sure you want to reset today's lesson for {childName}? This will allow them to start the lesson from the beginning.",
    lesson_reset_success: "Lesson has been reset! The child can now start fresh.",
    lesson_reset_error: "Could not reset the lesson. Please try again.",
    entry: "entry",
    entries: "entries",
    thoughts: "thoughts",
    lessons: "Lessons",
    
    // Share Section
    share_bible_buds_heading: "Share Bible Buds & Help It Go Viral!",
    share_bible_buds_desc: "Share our promo video with friends, family, and your church community!",
    promo_video: "Promo Video",
    download_to_share: "Download to Share",
    share_on: "Share on:",
    promotional_flyer: "Promotional Flyer",
    download_flyer: "Download Flyer",
    viral_tips_title: "Tips to Help Bible Buds Go Viral:",
    viral_tip_1: "Share in church Facebook groups",
    viral_tip_2: "Post on Christian parenting forums",
    viral_tip_3: "Send to homeschool communities",
    viral_tip_4: "Text the video to 5 friends today!",
    share_promo_text: "Check out Bible Buds! Daily Bible lessons, fun activities, and family study time for kids ages 3-18. Our family loves it! 🙏✨",
    flyer_tagline: "Teach Your Kids About God in Just 15 Minutes a Day!",
    help_spread_word: "Help Spread the Word!",
    share_flyer_desc: "Download and share this flyer with your church, friends, and family. Every share helps more families discover Bible Buds!",
    
    // Child Dashboard
    home: "Home",
    lesson: "Lesson",
    tasks: "Tasks",
    rewards: "Rewards",
    good_morning: "Good morning",
    good_afternoon: "Good afternoon",
    good_evening: "Good evening",
    ready_to_learn: "Ready to learn today?",
    todays_lesson: "Today's Lesson",
    start_lesson: "Start Lesson",
    continue_lesson: "Continue Lesson",
    lesson_completed: "Lesson Completed!",
    my_rewards: "My Rewards",
    study_with_family: "Study together with your family!",
    join: "JOIN",
    recent_badges: "Recent Badges",
    todays_adventure: "Today's Adventure",
    tap_to_start_lesson: "Tap to start your Bible lesson",
    start: "START",
    fun_activities: "Fun Activities",
    age: "Age",
    badges: "Badges",
    streak: "Streak",
    stars: "Stars",
    
    // Lesson Page
    preparing_lesson: "Preparing your lesson...",
    creating_special: "Creating something special for you!",
    todays_lesson_for: "Today's Lesson for",
    what_this_means: "What This Means",
    real_life_example: "Real Life Example",
    todays_moral: "Today's Lesson",
    fun_idea: "Fun Idea",
    i_learned_this: "I Learned This!",
    amazing_job: "Amazing job!",
    now_do_activities: "Now do the Activities!",
    
    // Quiz
    test_knowledge: "Test Your Knowledge!",
    quick_questions: "Quick Questions!",
    check_answers: "Check My Answers!",
    try_again: "Try Again",
    perfect: "Perfect!",
    great_job: "Great job!",
    keep_learning: "Keep learning!",
    understood_lesson: "You really understood today's lesson!",
    
    // Tasks
    daily_activities: "Daily Activities",
    complete_lesson_first: "Please complete today's lesson first to unlock tasks.",
    
    // Parent Dashboard Stats
    children_stat: "Children",
    todays_lessons_stat: "Today's Lessons",
    total_lessons_stat: "Total Lessons",
    stars_earned_stat: "Stars Earned",
    family_dashboard: "Family Dashboard",
    welcome_back: "Welcome back",
    add_child: "Add Child",
    edit_child: "Edit Child",
    delete_child: "Delete Child",
    child_name: "Child's Name",
    child_age: "Age",
    confirm_delete: "Are you sure?",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    update_password: "Update Password",
    password_changed: "Password changed successfully!",
    logout: "Logout",
    settings: "Settings",
    promo_materials: "Promotional Materials",
    download_video: "Download Video",
    download_flyer: "Download Flyer",
    share_with_friends: "Share with Friends",
    prayer_requests: "Prayer Requests",
    submit_prayer: "Submit Prayer Request",
    prayer_title: "Prayer Title",
    prayer_details: "Prayer Details",
    sending: "Sending...",
    send_prayer: "Send Prayer",
    prayer_submitted: "Prayer submitted!",
    family_devotional_history: "Family Devotional History",
    view_past_studies: "View past family studies",
    no_studies_yet: "No family studies yet",
    start_first_study: "Complete your first family study to see history here",
    
    // Family Study
    family_bible_study: "Family Bible Study",
    gather_family: "Gather the family — discuss today's lessons together!",
    what_kids_learned: "What the Kids Learned Today",
    quiz_answers: "Quiz Answers",
    discussion_questions: "Discussion Questions",
    family_activity: "Family Activity Time!",
    materials_needed: "Materials Needed",
    family_prayer: "Family Prayer",
    closing_blessing: "Closing Blessing",
    family_notes: "Family Notes",
    auto_saved: "auto-saved",
    family_notes_placeholder: "Write what your family discussed, prayer requests, or what you want to remember from today's study...",
    complete_family_study: "We Completed Our Family Study!",
    family_study_complete: "Family study complete!",
    great_job_studying: "Great job studying God's Word together today!",
    family_streak: "day family streak!",
    study: "Study",
    history: "History",
    
    // Lesson History
    lesson_history_title: "Lesson History",
    track_children_journey: "Track all your children's Bible journey",
    completed: "Completed",
    not_completed: "Not Completed",
    in_progress: "In Progress",
    no_lessons_yet: "No lessons yet",
    go_to_dashboard: "Go to Dashboard",
    
    // Age Groups
    little_light: "Little Light",
    bible_explorer: "Bible Explorer",
    faith_builder: "Faith Builder",
    age: "Age",
    
    // Add Child Modal
    add_new_child: "Add a Child",
    edit_child: "Edit Child",
    childs_name: "Child's Name",
    childs_name_placeholder: "e.g. Emma, Noah...",
    childs_age: "Child's Age",
    select_avatar: "Select Avatar",
    age_must_be_3_18: "Age must be between 3 and 18.",
    could_not_save_child: "Could not save child. Please try again.",
    age_3_18: "Age (3-18)",
    enter_age: "Enter age",
    ages: "ages",
    choose_avatar: "Choose an Avatar",
    save_changes: "Save Changes",
    add_child_btn: "Add Child!",
    
    // Rewards
    your_badges: "Your Badges",
    keep_learning_badges: "Keep learning to earn more badges!",
    rewards_for: "Rewards for",
    streak: "Streak",
    stars: "Stars",
    badges: "Badges",
    total_progress: "Total Progress",
    lessons_done: "Lessons Done",
    activities_done: "Activities Done",
    last_7_days: "Last 7 Days",
    badges_collection: "Badges Collection",
    earned: "Earned!",
    this_weeks_prize: "This Week's Prize",
    complete_to_earn: "Complete 5 lessons and 15 activities to earn your prize!",
    ask_parent_prize: "No weekly prize set yet",
    activities: "Activities",
    awesome: "Awesome!",
    you_did_it: "You Did It!",
    earned_weekly_prize: "You earned your weekly prize!",
    
    // Weekly Prize
    weekly_prize_for: "Weekly Prize for",
    set_reward_desc: "Set a reward they can earn by completing 5 lessons and 15 activities this week!",
    prize_name: "Prize Name",
    description_optional: "Description (optional)",
    current_prize: "Current prize:",
    set_prize: "Set Prize",
    update_prize: "Update Prize",
    prize: "Prize",
    
    // Badge names
    badge_first_steps: "First Steps!",
    badge_week_warrior: "Week Warrior",
    badge_star_student: "Star Student",
    badge_task_master: "Task Master",
    badge_faithful_friend: "Faithful Friend",
    badge_month_champion: "Month Champion",
    badge_first_steps_desc: "Complete your first lesson",
    badge_week_warrior_desc: "7 days of lessons in a row!",
    badge_star_student_desc: "10 lessons completed!",
    badge_task_master_desc: "10 activities finished!",
    badge_faithful_friend_desc: "30 lessons completed!",
    badge_month_champion_desc: "30-day streak!",
    
    // Tasks page
    todays_tasks: "Today's Tasks",
    complete_all_tasks: "Complete all tasks to earn stars!",
    mark_complete: "Mark Complete",
    task_completed: "Completed!",
    star: "star",
    back_to_dashboard: "Back to Dashboard",
    
    // Subscription
    subscription: "Subscription",
    free_trial: "7-day free trial",
    monthly_plan: "Monthly Plan",
    annual_plan: "Annual Plan",
    per_month: "/month",
    per_year: "/year",
    subscribe: "Subscribe",
    
    // Errors
    error_occurred: "An error occurred",
    could_not_load: "Could not load data. Please try again.",
    invalid_credentials: "Invalid email or password",
    
    // Lesson Page
    preparing_lesson: "Preparing your lesson...",
    creating_special: "Creating something special for you!",
    todays_lesson_for: "Today's Lesson for",
    bible_verse: "Bible Verse",
    what_this_means: "What This Means",
    real_life_example: "Real Life Example",
    todays_moral: "Today's Lesson",
    fun_idea: "Fun Idea",
    i_learned_this: "I Learned This!",
    amazing_job: "Amazing job!",
    now_do_activities: "Now do the Activities!",
    quiz_time: "Quiz Time!",
    check_my_answers: "Check My Answers!",
    try_again_quiz: "Try Again",
    perfect_score: "Perfect! You really understood today's lesson!",
    great_score: "Great job! Keep learning!",
    good_effort: "Good effort! Review the lesson and try again!",
    
    // Church Portal
    church_dashboard: "Church Dashboard",
    church_admin: "Church Admin",
    church_name: "Church Name",
    admin_name: "Admin Name",
    invite_code: "Invite Code",
    families: "Families",
    members: "Members",
    announcements: "Announcements",
    leaderboard: "Leaderboard",
    church_study: "Church Study",
    create_study: "Create Study",
    view_families: "View Families",
    send_announcement: "Send Announcement",
    no_families_yet: "No families have joined yet",
    share_invite_code: "Share this invite code with families",
    copy_code: "Copy Code",
    code_copied: "Code copied!",
    church_lesson_plan: "Church Lesson Plan",
    opening_prayer: "Opening Prayer",
    worship_songs: "Worship Songs",
    thanksgiving: "Thanksgiving",
    bible_reading: "Bible Reading",
    main_lesson: "Main Lesson",
    application: "Application",
    closing_prayer: "Closing Prayer",
    total_stars_earned: "Total Stars Earned",
    children_active: "Children Active",
    rank: "Rank",
    child_name: "Child Name",
    family_name: "Family",
    announcement_title: "Title",
    announcement_message: "Message",
    priority: "Priority",
    normal: "Normal",
    important: "Important",
    urgent: "Urgent",
    send: "Send",
    no_announcements: "No announcements yet",
    
    // Change Password Modal
    password_min_6: "New password must be at least 6 characters.",
    passwords_not_match: "New passwords don't match.",
    could_not_change_password: "Could not change password. Please try again.",
    password_changed: "Password Changed!",
    password_updated_success: "Your password has been updated successfully.",
    enter_current_new_password: "Enter your current and new password",
    enter_current_password: "Enter current password",
    enter_new_password: "Enter new password",
    confirm_new_password: "Confirm New Password",
    changing: "Changing...",
    
    // Set Prize Modal
    weekly_prize_for: "Weekly Prize for",
    set_reward_desc: "Set a reward they can earn by completing 5 lessons and 15 activities this week!",
    prize_name: "Prize Name",
    prize_placeholder: "e.g., Ice cream trip",
    description_optional: "Description (optional)",
    prize_desc_placeholder: "e.g., Any flavor you want!",
    current_prize_label: "Current prize",
    could_not_save_prize: "Could not save prize",
    update_prize: "Update Prize",
    set_prize: "Set Prize",
    prize_ice_cream: "Ice cream trip",
    prize_screen_time: "Extra screen time",
    prize_pick_dinner: "Pick dinner menu",
    prize_movie_night: "Movie night choice",
    prize_stay_up_late: "Stay up late",
    prize_new_book: "New book",
    prize_park_day: "Park day",
    prize_pizza_party: "Pizza party",
    
    // Kids Login
    im_a_kid: "I'm a Kid!",
    parents_sign_in_first: "Parents must sign in first on this device",
    select_your_profile: "Select Your Profile",
    who_is_learning: "Who's learning today?",
    back_to_home: "Back to Home",
    
    // Family Study Page
    preparing_family_study: "Preparing your family study...",
    creating_discussion: "Creating discussion questions!",
    almost_there: "Almost there!",
    parent_dashboard: "Parent Dashboard",
    todays_focus: "Today's Focus",
    day_family_streak: "day family streak!",
    older_kids: "Older kids",
    family_activity_time: "Family Activity Time!",
    study_history: "Study History",
    no_history_yet: "No history yet. Complete your first family study!",
    saving: "Saving...",
    
    // Tasks Page
    creating_activities: "Creating your activities...",
    read_lesson_first: "Read the lesson first!",
    go_to_lesson: "Go to Lesson",
    activities_for: "Activities for",
    of_done: "of",
    all_done_amazing: "All done! Amazing!",
    earned_stars_today: "You earned {count} stars today!",
    see_my_rewards: "See My Rewards!",
    question: "Question",
    journal: "Journal",
    challenge: "Challenge",
    prayer: "Prayer",
    
    // Church Dashboard
    children_by_age_group: "Children by Age Group",
    completed_lessons_by_family: "Completed Lessons by Family",
    track_family_progress: "Track each family's Bible learning progress",
    no_lessons_completed_yet: "No lessons completed yet",
    families_appear_here: "Families will appear here once they complete lessons",
    lessons: "lessons",
    child: "child",
    kids: "kids",
    little_lights_3_7: "Little Lights (3-7)",
    explorers_8_12: "Explorers (8-12)",
    faith_builders_13_18: "Faith Builders (13-18)",
    church_families: "Church Families",
    families_registered: "families registered",
    add: "Add",
    manage_church: "Manage your church",
    upgrade_church_premium: "Upgrade to Church Premium",
    manage_up_to_50: "Manage up to 50 families",
    
    // Church Families Page
    church_families_title: "Church Families",
    add_new_family: "Add New Family",
    family_email: "Family Email",
    family_password: "Family Password",
    add_family: "Add Family",
    remove_family: "Remove Family",
    confirm_remove: "Are you sure you want to remove this family?",
    
    // Church Study Page
    church_bible_study: "Church Bible Study",
    create_study_topic: "Create Study Topic",
    study_title: "Study Title",
    study_description: "Study Description",
    bible_verse_text: "Bible Verse Text",
    verse_reference: "Verse Reference",
    add_question: "Add Question",
    create_study_btn: "Create Study",
    no_studies_yet: "No Bible studies yet",
    todays_study: "Today's Study",
    create_topics_for_families: "Create topics for all families",
    create: "Create",
    create_first_study: "Create your first church-wide study topic",
    confirm_delete_study: "Delete this Bible study?",
    could_not_delete: "Could not delete",
    discussion_question: "Discussion Question",
    opening_prayer: "Opening Prayer",
    worship_songs: "Worship Songs",
    scripture_reading: "Scripture Reading",
    closing_prayer: "Closing Prayer",
    add_section: "Add Section",
    
    // Church Announcements
    church_announcements: "Church Announcements",
    new_announcement: "New Announcement",
    send_to_families: "Send to all families",
    posted: "Posted",
    send_messages_to_families: "Send messages to all families",
    new: "New",
    no_announcements_yet: "No announcements yet",
    send_first_message: "Send your first message to all families",
    confirm_delete_announcement: "Delete this announcement?",
    announcement_title: "Announcement Title",
    message: "Message",
    priority: "Priority",
    normal: "Normal",
    important: "Important",
    urgent: "Urgent",
    send_announcement: "Send Announcement",
    
    // Church Leaderboard
    church_leaderboard: "Church Leaderboard",
    top_learners: "Top Learners This Month",
    all_children: "All Children",
    top_bible_learners: "Top Bible learners in your church",
    no_data_yet: "No data yet",
    children_appear_here: "Children will appear here as they complete lessons",
    leaderboard: "Leaderboard",
    
    // Church Families Page
    confirm_remove_family: "Remove this family from your church?",
    could_not_remove: "Could not remove family",
    manage_families: "Manage your church families",
    no_families_yet: "No families yet",
    share_invite_code: "Share your invite code",
    add_family_manually: "Add Family Manually",
    
    // Subscription Page
    choose_your_plan: "Choose Your Plan",
    family_premium: "Family Premium",
    unlimited_children_desc: "Unlimited children, animations, family study, history, and daily reminders",
    best_value: "Best Value",
    save_70: "Save 70%",
    start_free_trial: "Start 7-Day Free Trial",
    then_billed: "then",
    monthly: "monthly",
    annually: "annually",
    current_plan: "Current Plan",
    manage_subscription: "Manage Subscription",
    trial_ends: "Trial ends",
    
    // Subscription Success
    subscription_success: "Subscription Successful!",
    welcome_to_premium: "Welcome to Bible Buds Premium!",
    enjoy_features: "Enjoy all premium features",
    go_to_dashboard: "Go to Dashboard",
    
    // Memory Verse
    memory_verse: "Memory Verse",
    memory_verse_of_week: "Memory Verse of the Week",
    memorized: "Memorized!",
    practice: "Practice",
    i_know_it: "I Know It!",
    practices: "practices",
    practice_more: "Practice {count} more time(s) to unlock completion!",
    ready_to_complete: "Ready to show you know it? Tap 'I Know It!'",
    you_memorized_it: "You Memorized It!",
    keep_saying_it: "Great job! Keep saying it every day!",
    tap_to_reveal: "Tap to reveal the verse!",
    can_you_remember: "Can you remember it?",
    
    // Family Devotional History
    family_devotional_history: "Family Devotional History",
    family_studies_completed: "family studies completed",
    your_spiritual_journey: "Your family's spiritual journey together",
    no_family_studies: "No family studies completed yet",
    start_first_study: "Start your first Family Bible Study to see your history here",
    overview: "Overview",
    childrens_lessons: "Children's Lessons",
    prayer_focus: "Prayer Focus",
    
    // Sing Praises
    sing_praises: "Sing Praises!",
    start_with_worship: "Start your family study with joyful worship songs",
    click_hymn_lyrics: "Begin your family Bible time by singing praises together! Click on any hymn below to view the full lyrics and sing along as a family.",
    hymns_from_hymnary: "All hymns link to Hymnary.org, a free resource for public domain hymns and worship songs.",
    
    // Share Section
    share_bible_buds: "Share Bible Buds",
    download_flyer_video: "Download our flyer and video to share with friends and family!",
    app_walkthrough_video: "App Walkthrough Video",
    promotional_flyer: "Promotional Flyer",
    download_flyer: "Download Flyer",
    download_video: "Download Video",
    share: "Share",
    discover_bible_buds: "Discover Bible Buds!",
    watch_walkthrough: "Watch our app walkthrough and download the flyer",
    
    // Landing Page
    daily_bible_lessons: "Daily Bible Lessons",
    ages_3_18: "ages 3-18",
    learn_weekly_verses: "Learn Weekly Bible Verses",
    family_worship_night: "Family Worship Night",
    fun_activities: "Fun Activities",
    rewards_and_badges: "Rewards and Badges",
    start_free_trial: "Start 7-Day Free Trial",
    
    // Analytics
    analytics: "Analytics",
    view_detailed_reports: "View detailed reports",
    lesson: "Lesson",
    
    // Curriculum Preview
    this_weeks_curriculum: "This Week's Curriculum",
    week: "Week",
    curriculum_complete: "complete",
    key_verse: "Key Verse",
    teaching_focus: "Teaching Focus",
    parent_tip: "Parent Tip",
    curriculum_parent_tip: "This week's lessons will focus on this theme. You can reinforce the message at home through conversation and activities!",
    view_full_curriculum: "View Full 30-Week Curriculum",
    full_curriculum_title: "30-Week Bible Journey",
    full_curriculum_subtitle: "Your family's faith adventure",
    your_progress: "Your Progress",
    of: "of",
    weeks_label: "weeks",
    current: "Current",
    upcoming: "Upcoming",
    completed: "Completed",
    this_week: "This Week",
    next_week: "Next Week",
    in: "In",
    scripture_reading: "Scripture",
    prepare_ahead: "Prepare Ahead",
    prepare_ahead_tip: "Read through the scripture this week so you're ready to discuss it with your children when this lesson arrives!",
    great_job: "Great Job",
    completed_week_tip: "Your family has already learned about this topic! Consider reviewing the key verse together to reinforce the message.",
    
    // Family Lesson Day
    weekly_family_lesson: "Weekly Family Lesson",
    change: "Change",
    family_lesson_tip: "Watch this video together as a family on your chosen day!",
    choose_lesson_day: "Choose Lesson Day",
    choose_lesson_day_subtitle: "When does your family watch together?",
    family_lesson_day_label: "Family Lesson Day",
    language_code: "en",
    
    // Journal
    todays_journal_entries: "Today's Journal Entries",
    all_journal_entries: "Children's Journal Entries",
    all_reflections: "Written reflections from your children",
    written_reflections: "Written reflections from your children today",
    no_journal_entries: "No journal entries yet",
    reflections_appear_here: "Children's written reflections will appear here",
    reflection: "Reflection",
    activity: "Activity",
    personal_journal: "Personal Journal",
    
    // Children's Rewards
    childrens_rewards: "Children's Rewards",
    track_rewards_progress: "Track weekly goals and earned rewards",
    no_rewards_yet: "No rewards set yet",
    set_rewards_hint: "Set weekly goals in each child's profile",
    claimed: "Claimed",
    in_progress: "In Progress",
    lessons_completed: "Lessons completed",
    week_of: "Week of",
    
    // Prayer Requests
    prayer_requests: "Prayer Requests",
    share_with_church: "Share with your church family",
    new_request: "New Request",
    no_prayer_requests: "No prayer requests yet",
    share_prayers_church: "Share your prayers with your church",
    answered: "Answered",
    praying: "Praying",
    pending: "Pending",
    
    // Drawing Canvas
    draw_something: "Draw something from today's lesson!",
    your_drawing: "Your Drawing",
    clear: "Clear",
    print: "Print",
    save: "Save",
    shapes: "Shapes",
    select_shape: "SELECT A SHAPE",
    eraser: "Erase",
    brush: "Brush",
    circle: "Circle",
    square: "Square",
    triangle: "Triangle",
    star_shape: "Star",
    heart_shape: "Heart",
    hexagon: "Hexagon",
    tap_to_place: "Tap anywhere to place a",
    
    // My Journal
    my_journal: "My Journal",
    write_thoughts: "Write your thoughts and prayers...",
    save_entry: "Save Entry",
    journal_saved: "Journal saved!",
    journal_placeholder: "Write about what you learned today, your prayers, or anything on your heart...",
    whats_on_mind: "What's on your mind today? Write anything here...",
    todays_thoughts: "Today's Thoughts",
    childrens_reflections: "Your children's written thoughts and reflections",
    journal_entries: "Journal Entries",
    lesson_reflections: "Answers from lesson reflection prompts",
    personal_thoughts_desc: "Personal thoughts your children wrote",
    personal_thought: "Personal thought",
    thought: "Thought",
    no_thoughts_yet: "No thoughts yet",
    thoughts_appear_here: "Children's personal thoughts will appear here",
    past_entries: "Past Entries",
    view_past_entries: "View {count} past entries",
    entries_today: "{count} entries today",
    
    // Weekly Prize Card
    prize_earned: "Prize Earned!",
    this_weeks_prize_title: "This Week's Prize",
    your_progress: "Your Progress",
    ask_mom_dad: "Ask mom or dad for your prize!",
    complete_to_earn_prize: "Complete {lessons} lessons and {tasks} activities to earn your prize!",
    
    // Memory Verse Card
    week_number: "Week {num}",
    practices_count: "{count}/5 practices",
    practice_to_unlock: "Practice {count} more time(s) to unlock completion!",
    
    // Church Dashboard
    processing: "Processing...",
    subscribe_now: "Subscribe Now",
    mark_praying: "Mark Praying",
    mark_answered: "Mark Answered",
    praying_status: "🙏 Praying",
    answered_status: "✓ Answered",
    could_not_update_status: "Could not update status",
    could_not_delete_request: "Could not delete prayer request",
    confirm_delete_prayer: "Are you sure you want to delete this prayer request?",
    could_not_start_checkout: "Could not start checkout",
    
    // Share Bible Buds Section
    share_bible_buds_heading: "Share Bible Buds",
    share_bible_buds_desc: "Download our flyer and video to share with friends and family!",
    written_reflections_today: "Written reflections from your children today",
    
    // Prayer Request Modal
    prayer_request_title: "Prayer Request",
    title_label: "Title",
    prayer_title_placeholder: "e.g., Healing for my grandmother",
    description_label: "Description",
    prayer_desc_placeholder: "Share more details about your prayer request...",
    mark_as_urgent: "Mark as important/urgent",
    submit: "Submit",
    could_not_submit_prayer: "Could not submit prayer request",
    admin_note_label: "Note:",
    question_prefix: "Q:",
    child_fallback: "Child",
    family_bible_study_fallback: "Family Bible Study",
    
    // Landing Page - Combined Section
    what_is_bible_buds: "What is Bible Buds?",
    bible_buds_description: "Bible Buds is a daily Bible learning app designed for children ages 3-18. Each day, kids receive age-appropriate lessons with engaging stories, fun activities, drawing canvases, and quizzes. Parents can track progress and join family study sessions together!",
    daily_lessons_feature: "Daily Lessons",
    drawing_art_feature: "Drawing & Art",
    family_study_feature: "Family Study",
    rewards_badges_feature: "Rewards & Badges",
    see_how_it_works: "See How It Works",
    app_demo: "App Demo",
    family_bible_time: "Family Bible Time",
    click_to_watch_song: "Click any song to watch and sing along on YouTube!",
    songs_open_youtube: "Songs open in YouTube for easy sing-along!",
    watch: "Watch",

    // Misc
    show_less: "Show less",
    read_more: "Read more",
    word_hunt: "Word Hunt!",
    word_hunt_desc: "These words are from today's lesson. Check them off as you find them in the story!",
    all_words_found: "You found all the words! Great job!",
    think_and_write: "Think & Write",
    write_thoughts: "Write your thoughts here...",
    correct: "Correct",
    not_answered: "Not answered",
    notes_from_parents: "Notes from Mom & Dad",
    allow_notifications: "Please allow notifications in your browser settings.",
    could_not_enable_notifications: "Could not enable notifications.",
    share_bible_buds_title: "Bible Buds - Daily Bible Lessons for Kids",
    share_bible_buds_text: "Check out Bible Buds! Daily Bible lessons, fun activities, and family study time for kids ages 3-18.",
    encouragement: "Encouragement",
    parent: "Parent",
    cancel_subscription_message: "To cancel your subscription, please reach out to us at",
    cancel_subscription_provide_email: "and provide the email used to log into biblebuds.space.",
    
    // Additional translations
    back: "Back",
    reading: "Reading...",
    practice: "Practice",
    saving: "Saving...",
    saved: "Saved!",
    overview: "Overview",
    childrens_lessons: "Children's Lessons",
    family_activity: "Family Activity",
    prayer_focus: "Prayer Focus",
    family_notes_label: "Family Notes",
    completed: "Completed",
    day_streak: "day streak",
    family_bible_study: "Family Bible Study",
    analytics_overview: "Analytics Overview",
    weekly_summary: "Weekly Summary",
    monthly_progress: "Monthly Progress",
    total_family_lessons: "Total Family Lessons",
    total_family_stars: "Total Family Stars",
    avg_completion_rate: "Avg. Completion Rate",
    most_active_child: "Most Active Child",
    contact_support: "Contact Support",
  },
  
  es: {
    // Common
    app_name: "Bible Buds",
    loading: "Cargando...",
    back: "Volver",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    open: "Abrir",
    close: "Cerrar",
    retry: "Intentar de nuevo",
    done: "listo",
    
    // Auth
    welcome: "¡Bienvenido a Bible Buds!",
    login: "Iniciar Sesión",
    parent_login: "Inicio de Padres",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    forgot_password: "¿Olvidaste tu contraseña?",
    change_password: "Cambiar Contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_password: "Confirmar Contraseña",
    login_btn: "Entrar",
    register_btn: "Crear Cuenta",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    select_language: "Seleccionar Idioma",
    start_free_trial: "¡Comenzar prueba gratis!",
    parent_sign_in: "Acceso de Padres",
    im_a_kid: "¡Soy un Niño!",
    parents_sign_first: "Los padres deben iniciar sesión primero en este dispositivo",
    need_help: "¿Necesitas ayuda?",
    create_secure_password: "Crea una contraseña segura",
    email_placeholder: "padre@email.com",
    your_full_name: "Tu nombre completo",
    choose_plan: "Elige Tu Plan",
    monthly_plan: "Plan Mensual",
    annual_plan: "Plan Anual",
    free_trial_then: "Prueba gratis de 7 días, luego cobro",
    save_percent: "Ahorra",
    per_month: "/mes",
    per_year: "/año",
    
    // Landing
    hero_title: "¡Lecciones Bíblicas Diarias para Niños!",
    hero_subtitle: "Lecciones y actividades bíblicas divertidas y apropiadas para la edad de tus hijos",
    get_started: "Comenzar",
    church_login: "Acceso Iglesia",
    kids_login: "Acceso Niños",
    
    // Parent Dashboard
    parent_dashboard: "Panel de Padres",
    welcome_back: "Bienvenido de nuevo",
    family_doing: "Así le está yendo a tu familia hoy.",
    your_children: "Tus Hijos",
    add_child: "Agregar Hijo",
    add_first_child: "¡Agrega tu primer hijo!",
    setup_profile: "Crea un perfil para comenzar su viaje bíblico.",
    children: "Hijos",
    today_lessons: "Lecciones de Hoy",
    total_lessons: "Total de Lecciones",
    stars_earned: "Estrellas Ganadas",
    lesson_history: "Historial de Lecciones",
    track_progress: "Ver progreso",
    reminders_on: "Recordatorios Activos",
    reminders_off: "Recordatorios Desactivados",
    daily_reminder: "Diario 10 AM",
    tap_enable: "Toca para activar",
    weekly_email_on: "Email Semanal: Activado",
    weekly_email_off: "Email Semanal: Desactivado",
    weekly_email_desc: "Recibe un resumen dominical del progreso de tu familia",
    verse_practice: "Juego de Versículos",
    practice_memorize: "¡Juega juegos divertidos para memorizar el versículo de la semana!",
    play: "Jugar",
    view_all: "Ver",
    logout: "Cerrar Sesión",
    prize: "Premio",
    del: "Elim",
    confirm_remove_child: "¿Eliminar este perfil de hijo?",
    could_not_delete: "No se pudo eliminar.",
    reset_today_lesson: "Reiniciar Lección de Hoy",
    confirm_reset_lesson: "¿Estás seguro de que quieres reiniciar la lección de hoy para {childName}? Esto le permitirá comenzar la lección desde el principio.",
    lesson_reset_success: "¡La lección ha sido reiniciada! El niño puede comenzar de nuevo.",
    lesson_reset_error: "No se pudo reiniciar la lección. Por favor, intenta de nuevo.",
    entry: "entrada",
    entries: "entradas",
    thoughts: "pensamientos",
    lessons: "Lecciones",
    
    // Share Section
    share_bible_buds_heading: "¡Comparte Bible Buds y Hazlo Viral!",
    share_bible_buds_desc: "¡Comparte nuestro video promocional con amigos, familia y tu comunidad de la iglesia!",
    promo_video: "Video Promocional",
    download_to_share: "Descargar para Compartir",
    share_on: "Compartir en:",
    promotional_flyer: "Folleto Promocional",
    download_flyer: "Descargar Folleto",
    viral_tips_title: "Consejos para Hacer Viral Bible Buds:",
    viral_tip_1: "Comparte en grupos de Facebook de iglesias",
    viral_tip_2: "Publica en foros de padres cristianos",
    viral_tip_3: "Envía a comunidades de educación en casa",
    viral_tip_4: "¡Envía el video a 5 amigos hoy!",
    share_promo_text: "¡Mira Bible Buds! Lecciones bíblicas diarias, actividades divertidas y tiempo de estudio familiar para niños de 3 a 18 años. ¡A nuestra familia le encanta! 🙏✨",
    flyer_tagline: "¡Enseña a Tus Hijos Sobre Dios en Solo 15 Minutos al Día!",
    help_spread_word: "¡Ayuda a Correr la Voz!",
    share_flyer_desc: "Descarga y comparte este folleto con tu iglesia, amigos y familia. ¡Cada vez que compartes, más familias descubren Bible Buds!",
    
    // Child Dashboard
    home: "Inicio",
    lesson: "Lección",
    tasks: "Tareas",
    rewards: "Premios",
    good_morning: "Buenos días",
    good_afternoon: "Buenas tardes",
    good_evening: "Buenas noches",
    ready_to_learn: "¿Listo para aprender hoy?",
    todays_lesson: "Lección de Hoy",
    start_lesson: "Comenzar Lección",
    continue_lesson: "Continuar Lección",
    lesson_completed: "¡Lección Completada!",
    my_rewards: "Mis Premios",
    study_with_family: "¡Estudia junto a tu familia!",
    join: "UNIRME",
    recent_badges: "Insignias Recientes",
    todays_adventure: "Aventura de Hoy",
    tap_to_start_lesson: "Toca para comenzar tu lección bíblica",
    start: "INICIAR",
    fun_activities: "Actividades Divertidas",
    age: "Edad",
    badges: "Insignias",
    streak: "Racha",
    stars: "Estrellas",
    
    // Lesson Page
    preparing_lesson: "Preparando tu lección...",
    creating_special: "¡Creando algo especial para ti!",
    todays_lesson_for: "Lección de Hoy para",
    what_this_means: "Qué Significa Esto",
    real_life_example: "Ejemplo de la Vida Real",
    todays_moral: "Lección de Hoy",
    fun_idea: "Idea Divertida",
    i_learned_this: "¡Ya lo Aprendí!",
    amazing_job: "¡Excelente trabajo!",
    now_do_activities: "¡Ahora haz las Actividades!",
    
    // Quiz
    test_knowledge: "¡Prueba tus Conocimientos!",
    quick_questions: "¡Preguntas Rápidas!",
    check_answers: "¡Revisar mis Respuestas!",
    try_again: "Intentar de Nuevo",
    perfect: "¡Perfecto!",
    great_job: "¡Muy bien!",
    keep_learning: "¡Sigue aprendiendo!",
    understood_lesson: "¡Entendiste muy bien la lección de hoy!",
    
    // Tasks
    daily_activities: "Actividades Diarias",
    complete_lesson_first: "Por favor completa la lección de hoy primero para desbloquear las tareas.",
    
    // Parent Dashboard Stats
    children_stat: "Niños",
    todays_lessons_stat: "Lecciones de Hoy",
    total_lessons_stat: "Total de Lecciones",
    stars_earned_stat: "Estrellas Ganadas",
    family_dashboard: "Panel Familiar",
    welcome_back: "Bienvenido de nuevo",
    add_child: "Agregar Niño",
    edit_child: "Editar Niño",
    delete_child: "Eliminar Niño",
    child_name: "Nombre del Niño",
    child_age: "Edad",
    confirm_delete: "¿Estás seguro?",
    change_password: "Cambiar Contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_password: "Confirmar Contraseña",
    update_password: "Actualizar Contraseña",
    password_changed: "¡Contraseña cambiada exitosamente!",
    logout: "Cerrar Sesión",
    settings: "Configuración",
    promo_materials: "Materiales Promocionales",
    download_video: "Descargar Video",
    download_flyer: "Descargar Folleto",
    share_with_friends: "Compartir con Amigos",
    prayer_requests: "Peticiones de Oración",
    submit_prayer: "Enviar Petición de Oración",
    prayer_title: "Título de la Oración",
    prayer_details: "Detalles de la Oración",
    sending: "Enviando...",
    send_prayer: "Enviar Oración",
    prayer_submitted: "¡Oración enviada!",
    family_devotional_history: "Historial Devocional Familiar",
    view_past_studies: "Ver estudios familiares anteriores",
    no_studies_yet: "Aún no hay estudios familiares",
    start_first_study: "Completa tu primer estudio familiar para ver el historial aquí",
    
    // Family Study
    family_bible_study: "Estudio Bíblico Familiar",
    gather_family: "¡Reúne a la familia — discutan las lecciones de hoy juntos!",
    what_kids_learned: "Lo que Aprendieron los Niños Hoy",
    quiz_answers: "Respuestas del Quiz",
    discussion_questions: "Preguntas de Discusión",
    family_activity: "¡Hora de Actividad Familiar!",
    materials_needed: "Materiales Necesarios",
    family_prayer: "Oración Familiar",
    closing_blessing: "Bendición Final",
    family_notes: "Notas Familiares",
    auto_saved: "guardado automático",
    family_notes_placeholder: "Escribe lo que discutió tu familia, peticiones de oración, o lo que quieras recordar del estudio de hoy...",
    complete_family_study: "¡Completamos Nuestro Estudio Familiar!",
    family_study_complete: "¡Estudio familiar completo!",
    great_job_studying: "¡Excelente trabajo estudiando la Palabra de Dios juntos hoy!",
    family_streak: "días de racha familiar!",
    study: "Estudio",
    history: "Historial",
    
    // Lesson History
    lesson_history_title: "Historial de Lecciones",
    track_children_journey: "Sigue el viaje bíblico de todos tus hijos",
    completed: "Completado",
    not_completed: "No Completado",
    in_progress: "En Progreso",
    no_lessons_yet: "Aún no hay lecciones",
    go_to_dashboard: "Ir al Panel",
    
    // Age Groups
    little_light: "Pequeña Luz",
    bible_explorer: "Explorador Bíblico",
    faith_builder: "Constructor de Fe",
    age: "Edad",
    
    // Add Child Modal
    add_new_child: "Agregar un Hijo",
    edit_child: "Editar Hijo",
    childs_name: "Nombre del Niño",
    childs_name_placeholder: "ej. Emma, Noah...",
    childs_age: "Edad del Niño",
    select_avatar: "Seleccionar Avatar",
    age_must_be_3_18: "La edad debe estar entre 3 y 18.",
    could_not_save_child: "No se pudo guardar. Inténtalo de nuevo.",
    age_3_18: "Edad (3-18)",
    enter_age: "Ingresa edad",
    ages: "edades",
    choose_avatar: "Elige un Avatar",
    save_changes: "Guardar Cambios",
    add_child_btn: "¡Agregar Hijo!",
    
    // Rewards
    your_badges: "Tus Insignias",
    keep_learning_badges: "¡Sigue aprendiendo para ganar más insignias!",
    rewards_for: "Premios para",
    streak: "Racha",
    stars: "Estrellas",
    badges: "Insignias",
    total_progress: "Progreso Total",
    lessons_done: "Lecciones Hechas",
    activities_done: "Actividades Hechas",
    last_7_days: "Últimos 7 Días",
    badges_collection: "Colección de Insignias",
    earned: "¡Ganado!",
    this_weeks_prize: "Premio de Esta Semana",
    complete_to_earn: "¡Completa 5 lecciones y 15 actividades para ganar tu premio!",
    ask_parent_prize: "Aún no hay premio semanal",
    activities: "Actividades",
    awesome: "¡Increíble!",
    you_did_it: "¡Lo Lograste!",
    earned_weekly_prize: "¡Ganaste tu premio semanal!",
    
    // Weekly Prize
    weekly_prize_for: "Premio Semanal para",
    set_reward_desc: "¡Establece una recompensa que pueden ganar completando 5 lecciones y 15 actividades esta semana!",
    prize_name: "Nombre del Premio",
    description_optional: "Descripción (opcional)",
    current_prize: "Premio actual:",
    set_prize: "Establecer Premio",
    update_prize: "Actualizar Premio",
    prize: "Premio",
    
    // Badge names
    badge_first_steps: "¡Primeros Pasos!",
    badge_week_warrior: "Guerrero Semanal",
    badge_star_student: "Estudiante Estrella",
    badge_task_master: "Maestro de Tareas",
    badge_faithful_friend: "Amigo Fiel",
    badge_month_champion: "Campeón del Mes",
    badge_first_steps_desc: "Completa tu primera lección",
    badge_week_warrior_desc: "¡7 días de lecciones seguidos!",
    badge_star_student_desc: "¡10 lecciones completadas!",
    badge_task_master_desc: "¡10 actividades terminadas!",
    badge_faithful_friend_desc: "¡30 lecciones completadas!",
    badge_month_champion_desc: "¡Racha de 30 días!",
    
    // Tasks page
    todays_tasks: "Tareas de Hoy",
    complete_all_tasks: "¡Completa todas las tareas para ganar estrellas!",
    mark_complete: "Marcar Completa",
    task_completed: "¡Completada!",
    star: "estrella",
    back_to_dashboard: "Volver al Panel",
    
    // Subscription
    subscription: "Suscripción",
    free_trial: "7 días de prueba gratis",
    monthly_plan: "Plan Mensual",
    annual_plan: "Plan Anual",
    per_month: "/mes",
    per_year: "/año",
    subscribe: "Suscribirse",
    
    // Errors
    error_occurred: "Ocurrió un error",
    could_not_load: "No se pudieron cargar los datos. Por favor intenta de nuevo.",
    invalid_credentials: "Correo o contraseña inválidos",
    
    // Lesson Page
    preparing_lesson: "Preparando tu lección...",
    creating_special: "¡Creando algo especial para ti!",
    todays_lesson_for: "Lección de Hoy para",
    bible_verse: "Versículo Bíblico",
    what_this_means: "Qué Significa Esto",
    real_life_example: "Ejemplo de la Vida Real",
    todays_moral: "Lección de Hoy",
    fun_idea: "Idea Divertida",
    i_learned_this: "¡Ya lo Aprendí!",
    amazing_job: "¡Excelente trabajo!",
    now_do_activities: "¡Ahora haz las Actividades!",
    quiz_time: "¡Hora del Quiz!",
    check_my_answers: "¡Revisar mis Respuestas!",
    try_again_quiz: "Intentar de Nuevo",
    perfect_score: "¡Perfecto! ¡Entendiste muy bien la lección de hoy!",
    great_score: "¡Muy bien! ¡Sigue aprendiendo!",
    good_effort: "¡Buen esfuerzo! Repasa la lección e intenta de nuevo.",
    
    // Church Portal
    church_dashboard: "Panel de la Iglesia",
    church_admin: "Administrador de Iglesia",
    church_name: "Nombre de la Iglesia",
    admin_name: "Nombre del Administrador",
    invite_code: "Código de Invitación",
    families: "Familias",
    members: "Miembros",
    announcements: "Anuncios",
    leaderboard: "Tabla de Líderes",
    church_study: "Estudio de la Iglesia",
    create_study: "Crear Estudio",
    view_families: "Ver Familias",
    send_announcement: "Enviar Anuncio",
    no_families_yet: "Aún no se han unido familias",
    share_invite_code: "Comparte este código de invitación con las familias",
    copy_code: "Copiar Código",
    code_copied: "¡Código copiado!",
    church_lesson_plan: "Plan de Lección de la Iglesia",
    opening_prayer: "Oración de Apertura",
    worship_songs: "Canciones de Adoración",
    thanksgiving: "Acción de Gracias",
    bible_reading: "Lectura Bíblica",
    main_lesson: "Lección Principal",
    application: "Aplicación",
    closing_prayer: "Oración de Cierre",
    total_stars_earned: "Total de Estrellas Ganadas",
    children_active: "Niños Activos",
    rank: "Posición",
    child_name: "Nombre del Niño",
    family_name: "Familia",
    announcement_title: "Título",
    announcement_message: "Mensaje",
    priority: "Prioridad",
    normal: "Normal",
    important: "Importante",
    urgent: "Urgente",
    send: "Enviar",
    no_announcements: "Aún no hay anuncios",
    
    // Change Password Modal
    password_min_6: "La nueva contraseña debe tener al menos 6 caracteres.",
    passwords_not_match: "Las contraseñas no coinciden.",
    could_not_change_password: "No se pudo cambiar la contraseña. Inténtalo de nuevo.",
    password_changed: "¡Contraseña Cambiada!",
    password_updated_success: "Tu contraseña ha sido actualizada exitosamente.",
    enter_current_new_password: "Ingresa tu contraseña actual y nueva",
    enter_current_password: "Ingresa contraseña actual",
    enter_new_password: "Ingresa nueva contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña",
    changing: "Cambiando...",
    
    // Set Prize Modal
    weekly_prize_for: "Premio Semanal para",
    set_reward_desc: "¡Establece una recompensa que pueden ganar completando 5 lecciones y 15 actividades esta semana!",
    prize_name: "Nombre del Premio",
    prize_placeholder: "ej., Paseo por helado",
    description_optional: "Descripción (opcional)",
    prize_desc_placeholder: "ej., ¡El sabor que quieras!",
    current_prize_label: "Premio actual",
    could_not_save_prize: "No se pudo guardar el premio",
    update_prize: "Actualizar Premio",
    set_prize: "Establecer Premio",
    prize_ice_cream: "Paseo por helado",
    prize_screen_time: "Tiempo extra de pantalla",
    prize_pick_dinner: "Elegir el menú",
    prize_movie_night: "Elegir película",
    prize_stay_up_late: "Acostarse tarde",
    prize_new_book: "Libro nuevo",
    prize_park_day: "Día en el parque",
    prize_pizza_party: "Fiesta de pizza",
    
    // Kids Login
    im_a_kid: "¡Soy un Niño!",
    parents_sign_in_first: "Los padres deben iniciar sesión primero en este dispositivo",
    select_your_profile: "Selecciona Tu Perfil",
    who_is_learning: "¿Quién aprende hoy?",
    back_to_home: "Volver al Inicio",
    
    // Family Study Page
    preparing_family_study: "Preparando tu estudio familiar...",
    creating_discussion: "¡Creando preguntas de discusión!",
    almost_there: "¡Casi listo!",
    parent_dashboard: "Panel de Padres",
    todays_focus: "Enfoque de Hoy",
    day_family_streak: "día de racha familiar!",
    older_kids: "Niños mayores",
    family_activity_time: "¡Hora de Actividad Familiar!",
    study_history: "Historial de Estudios",
    no_history_yet: "Aún no hay historial. ¡Completa tu primer estudio familiar!",
    saving: "Guardando...",
    
    // Tasks Page
    creating_activities: "Creando tus actividades...",
    read_lesson_first: "¡Lee la lección primero!",
    go_to_lesson: "Ir a la Lección",
    activities_for: "Actividades para",
    of_done: "de",
    all_done_amazing: "¡Todo listo! ¡Increíble!",
    earned_stars_today: "¡Ganaste {count} estrellas hoy!",
    see_my_rewards: "¡Ver Mis Premios!",
    question: "Pregunta",
    journal: "Diario",
    challenge: "Desafío",
    prayer: "Oración",
    
    // Church Dashboard
    children_by_age_group: "Niños por Grupo de Edad",
    completed_lessons_by_family: "Lecciones Completadas por Familia",
    track_family_progress: "Sigue el progreso de aprendizaje bíblico de cada familia",
    no_lessons_completed_yet: "Aún no hay lecciones completadas",
    families_appear_here: "Las familias aparecerán aquí cuando completen lecciones",
    lessons: "lecciones",
    child: "hijo",
    kids: "hijos",
    little_lights_3_7: "Pequeñas Luces (3-7)",
    explorers_8_12: "Exploradores (8-12)",
    faith_builders_13_18: "Constructores de Fe (13-18)",
    church_families: "Familias de la Iglesia",
    families_registered: "familias registradas",
    add: "Agregar",
    manage_church: "Administra tu iglesia",
    upgrade_church_premium: "Actualizar a Iglesia Premium",
    manage_up_to_50: "Administra hasta 50 familias",
    
    // Church Families Page
    church_families_title: "Familias de la Iglesia",
    add_new_family: "Agregar Nueva Familia",
    family_email: "Correo de la Familia",
    family_password: "Contraseña de la Familia",
    add_family: "Agregar Familia",
    remove_family: "Eliminar Familia",
    confirm_remove: "¿Estás seguro de que quieres eliminar esta familia?",
    
    // Church Study Page
    church_bible_study: "Estudio Bíblico de la Iglesia",
    create_study_topic: "Crear Tema de Estudio",
    study_title: "Título del Estudio",
    study_description: "Descripción del Estudio",
    bible_verse_text: "Texto del Versículo Bíblico",
    verse_reference: "Referencia del Versículo",
    add_question: "Agregar Pregunta",
    create_study_btn: "Crear Estudio",
    no_studies_yet: "Aún no hay estudios bíblicos",
    todays_study: "Estudio de Hoy",
    create_topics_for_families: "Crear temas para todas las familias",
    create: "Crear",
    create_first_study: "Crea tu primer tema de estudio para la iglesia",
    confirm_delete_study: "¿Eliminar este estudio bíblico?",
    could_not_delete: "No se pudo eliminar",
    discussion_question: "Pregunta de Discusión",
    opening_prayer: "Oración de Apertura",
    worship_songs: "Canciones de Adoración",
    scripture_reading: "Lectura de las Escrituras",
    closing_prayer: "Oración de Cierre",
    add_section: "Agregar Sección",
    
    // Church Announcements
    church_announcements: "Anuncios de la Iglesia",
    new_announcement: "Nuevo Anuncio",
    send_to_families: "Enviar a todas las familias",
    posted: "Publicado",
    send_messages_to_families: "Enviar mensajes a todas las familias",
    new: "Nuevo",
    no_announcements_yet: "Aún no hay anuncios",
    send_first_message: "Envía tu primer mensaje a todas las familias",
    confirm_delete_announcement: "¿Eliminar este anuncio?",
    announcement_title: "Título del Anuncio",
    message: "Mensaje",
    priority: "Prioridad",
    normal: "Normal",
    important: "Importante",
    urgent: "Urgente",
    send_announcement: "Enviar Anuncio",
    
    // Church Leaderboard
    church_leaderboard: "Tabla de Líderes de la Iglesia",
    top_learners: "Mejores Aprendices Este Mes",
    all_children: "Todos los Niños",
    top_bible_learners: "Los mejores aprendices de la Biblia en tu iglesia",
    no_data_yet: "Aún no hay datos",
    children_appear_here: "Los niños aparecerán aquí cuando completen lecciones",
    leaderboard: "Tabla de Líderes",
    
    // Church Families Page
    confirm_remove_family: "¿Eliminar esta familia de tu iglesia?",
    could_not_remove: "No se pudo eliminar la familia",
    manage_families: "Administra las familias de tu iglesia",
    no_families_yet: "Aún no hay familias",
    share_invite_code: "Comparte tu código de invitación",
    add_family_manually: "Agregar Familia Manualmente",
    
    // Subscription Page
    choose_your_plan: "Elige Tu Plan",
    family_premium: "Familia Premium",
    unlimited_children_desc: "Hijos ilimitados, animaciones, estudio familiar, historial y recordatorios diarios",
    best_value: "Mejor Valor",
    save_70: "Ahorra 70%",
    start_free_trial: "Comenzar Prueba Gratis de 7 Días",
    then_billed: "luego",
    monthly: "mensual",
    annually: "anual",
    current_plan: "Plan Actual",
    manage_subscription: "Administrar Suscripción",
    trial_ends: "Prueba termina",
    
    // Subscription Success
    subscription_success: "¡Suscripción Exitosa!",
    welcome_to_premium: "¡Bienvenido a Bible Buds Premium!",
    enjoy_features: "Disfruta todas las funciones premium",
    go_to_dashboard: "Ir al Panel",
    
    // Memory Verse
    memory_verse: "Versículo para Memorizar",
    memory_verse_of_week: "Versículo de la Semana",
    memorized: "¡Memorizado!",
    practice: "Practicar",
    i_know_it: "¡Ya lo Sé!",
    practices: "prácticas",
    practice_more: "¡Practica {count} vez/veces más para desbloquear!",
    ready_to_complete: "¿Listo para demostrar que lo sabes? ¡Toca 'Ya lo Sé!'",
    you_memorized_it: "¡Lo Memorizaste!",
    keep_saying_it: "¡Excelente! ¡Sigue repitiéndolo cada día!",
    tap_to_reveal: "¡Toca para revelar el versículo!",
    can_you_remember: "¿Puedes recordarlo?",
    
    // Family Devotional History
    family_devotional_history: "Historial Devocional Familiar",
    family_studies_completed: "estudios familiares completados",
    your_spiritual_journey: "El viaje espiritual de tu familia juntos",
    no_family_studies: "Aún no hay estudios familiares completados",
    start_first_study: "Comienza tu primer Estudio Bíblico Familiar para ver tu historial aquí",
    overview: "Resumen",
    childrens_lessons: "Lecciones de los Niños",
    prayer_focus: "Enfoque de Oración",
    
    // Sing Praises
    sing_praises: "¡Cantemos Alabanzas!",
    start_with_worship: "Comienza tu estudio familiar con canciones de adoración",
    click_hymn_lyrics: "¡Comienza tu tiempo bíblico familiar cantando alabanzas juntos! Haz clic en cualquier himno para ver la letra completa y cantar en familia.",
    hymns_from_hymnary: "Todos los himnos enlazan a Hymnary.org, un recurso gratuito de himnos de dominio público.",
    
    // Share Section
    share_bible_buds: "Comparte Bible Buds",
    download_flyer_video: "¡Descarga nuestro volante y video para compartir con amigos y familia!",
    app_walkthrough_video: "Video de Demostración",
    promotional_flyer: "Volante Promocional",
    download_flyer: "Descargar Volante",
    download_video: "Descargar Video",
    share: "Compartir",
    discover_bible_buds: "¡Descubre Bible Buds!",
    watch_walkthrough: "Mira la demostración de la app y descarga el volante",
    
    // Landing Page
    daily_bible_lessons: "Lecciones Bíblicas Diarias",
    ages_3_18: "edades 3-18",
    learn_weekly_verses: "Aprende Versículos Semanales",
    family_worship_night: "Noche de Adoración Familiar",
    fun_activities: "Actividades Divertidas",
    rewards_and_badges: "Premios e Insignias",
    start_free_trial: "Comenzar Prueba Gratis de 7 Días",
    
    // Analytics
    analytics: "Análisis",
    view_detailed_reports: "Ver reportes detallados",
    lesson: "Lección",
    
    // Curriculum Preview
    this_weeks_curriculum: "El Currículo de Esta Semana",
    week: "Semana",
    curriculum_complete: "completado",
    key_verse: "Versículo Clave",
    teaching_focus: "Enfoque de Enseñanza",
    parent_tip: "Consejo para Padres",
    curriculum_parent_tip: "Las lecciones de esta semana se enfocarán en este tema. ¡Puedes reforzar el mensaje en casa a través de conversaciones y actividades!",
    view_full_curriculum: "Ver el Currículo Completo de 30 Semanas",
    full_curriculum_title: "Jornada Bíblica de 30 Semanas",
    full_curriculum_subtitle: "La aventura de fe de tu familia",
    your_progress: "Tu Progreso",
    of: "de",
    weeks_label: "semanas",
    current: "Actual",
    upcoming: "Próximo",
    completed: "Completado",
    this_week: "Esta Semana",
    next_week: "Próxima Semana",
    in: "En",
    scripture_reading: "Escritura",
    prepare_ahead: "Prepárate con Anticipación",
    prepare_ahead_tip: "¡Lee la escritura esta semana para estar listo para discutirla con tus hijos cuando llegue esta lección!",
    great_job: "¡Excelente Trabajo!",
    completed_week_tip: "¡Tu familia ya aprendió sobre este tema! Considera repasar el versículo clave juntos para reforzar el mensaje.",
    
    // Family Lesson Day
    weekly_family_lesson: "Lección Familiar Semanal",
    change: "Cambiar",
    family_lesson_tip: "¡Mira este video junto con tu familia en el día elegido!",
    choose_lesson_day: "Elegir Día de Lección",
    choose_lesson_day_subtitle: "¿Cuándo ve la familia junta?",
    family_lesson_day_label: "Día de Lección Familiar",
    language_code: "es",
    
    // Journal
    todays_journal_entries: "Entradas de Diario de Hoy",
    all_journal_entries: "Entradas de Diario de los Niños",
    all_reflections: "Reflexiones escritas de tus hijos",
    written_reflections: "Reflexiones escritas de tus hijos hoy",
    no_journal_entries: "Aún no hay entradas de diario",
    reflections_appear_here: "Las reflexiones escritas de los niños aparecerán aquí",
    reflection: "Reflexión",
    activity: "Actividad",
    personal_journal: "Diario Personal",
    
    // Children's Rewards
    childrens_rewards: "Recompensas de los Niños",
    track_rewards_progress: "Seguimiento de metas semanales y recompensas",
    no_rewards_yet: "Aún no hay recompensas",
    set_rewards_hint: "Establece metas semanales en el perfil de cada niño",
    claimed: "Reclamada",
    in_progress: "En Progreso",
    lessons_completed: "Lecciones completadas",
    week_of: "Semana del",
    
    // Prayer Requests
    prayer_requests: "Peticiones de Oración",
    share_with_church: "Comparte con tu familia de la iglesia",
    new_request: "Nueva Petición",
    no_prayer_requests: "Aún no hay peticiones de oración",
    share_prayers_church: "Comparte tus oraciones con tu iglesia",
    answered: "Contestada",
    praying: "Orando",
    pending: "Pendiente",
    
    // Drawing Canvas
    draw_something: "¡Dibuja algo de la lección de hoy!",
    your_drawing: "Tu Dibujo",
    clear: "Limpiar",
    print: "Imprimir",
    save: "Guardar",
    shapes: "Formas",
    select_shape: "SELECCIONA UNA FORMA",
    eraser: "Borrar",
    brush: "Pincel",
    circle: "Círculo",
    square: "Cuadrado",
    triangle: "Triángulo",
    star_shape: "Estrella",
    heart_shape: "Corazón",
    hexagon: "Hexágono",
    tap_to_place: "Toca en cualquier lugar para colocar un/una",
    
    // My Journal
    my_journal: "Mi Diario",
    write_thoughts: "Escribe tus pensamientos y oraciones...",
    save_entry: "Guardar Entrada",
    journal_saved: "¡Diario guardado!",
    journal_placeholder: "Escribe sobre lo que aprendiste hoy, tus oraciones, o cualquier cosa en tu corazón...",
    whats_on_mind: "¿Qué tienes en mente hoy? Escribe cualquier cosa aquí...",
    todays_thoughts: "Pensamientos de Hoy",
    childrens_reflections: "Los pensamientos y reflexiones escritos de tus hijos",
    journal_entries: "Entradas del Diario",
    lesson_reflections: "Respuestas a las preguntas de reflexión de la lección",
    personal_thoughts_desc: "Pensamientos personales que escribieron tus hijos",
    personal_thought: "Pensamiento personal",
    thought: "Pensamiento",
    no_thoughts_yet: "Aún no hay pensamientos",
    thoughts_appear_here: "Los pensamientos personales de los niños aparecerán aquí",
    past_entries: "Entradas Anteriores",
    view_past_entries: "Ver {count} entradas anteriores",
    entries_today: "{count} entradas hoy",
    
    // Weekly Prize Card
    prize_earned: "¡Premio Ganado!",
    this_weeks_prize_title: "Premio de Esta Semana",
    your_progress: "Tu Progreso",
    ask_mom_dad: "¡Pídele a mamá o papá tu premio!",
    complete_to_earn_prize: "¡Completa {lessons} lecciones y {tasks} actividades para ganar tu premio!",
    
    // Memory Verse Card
    week_number: "Semana {num}",
    practices_count: "{count}/5 prácticas",
    practice_to_unlock: "¡Practica {count} vez/veces más para desbloquear!",
    
    // Church Dashboard
    processing: "Procesando...",
    subscribe_now: "Suscribirse Ahora",
    mark_praying: "Marcar Orando",
    mark_answered: "Marcar Contestada",
    praying_status: "🙏 Orando",
    answered_status: "✓ Contestada",
    could_not_update_status: "No se pudo actualizar el estado",
    could_not_delete_request: "No se pudo eliminar la petición de oración",
    confirm_delete_prayer: "¿Estás seguro de que quieres eliminar esta petición de oración?",
    could_not_start_checkout: "No se pudo iniciar el pago",
    
    // Share Bible Buds Section
    share_bible_buds_heading: "Comparte Bible Buds",
    share_bible_buds_desc: "¡Descarga nuestro volante y video para compartir con amigos y familia!",
    written_reflections_today: "Reflexiones escritas de tus hijos hoy",
    
    // Prayer Request Modal
    prayer_request_title: "Petición de Oración",
    title_label: "Título",
    prayer_title_placeholder: "ej., Sanidad para mi abuela",
    description_label: "Descripción",
    prayer_desc_placeholder: "Comparte más detalles sobre tu petición de oración...",
    mark_as_urgent: "Marcar como importante/urgente",
    submit: "Enviar",
    could_not_submit_prayer: "No se pudo enviar la petición de oración",
    admin_note_label: "Nota:",
    question_prefix: "P:",
    child_fallback: "Niño",
    family_bible_study_fallback: "Estudio Bíblico Familiar",
    
    // Landing Page - Combined Section
    what_is_bible_buds: "¿Qué es Bible Buds?",
    bible_buds_description: "Bible Buds es una aplicación de aprendizaje bíblico diario diseñada para niños de 3 a 18 años. Cada día, los niños reciben lecciones apropiadas para su edad con historias interesantes, actividades divertidas, lienzos para dibujar y cuestionarios. ¡Los padres pueden seguir el progreso y unirse a sesiones de estudio familiar!",
    daily_lessons_feature: "Lecciones Diarias",
    drawing_art_feature: "Dibujo y Arte",
    family_study_feature: "Estudio Familiar",
    rewards_badges_feature: "Premios e Insignias",
    see_how_it_works: "Mira Cómo Funciona",
    app_demo: "Demo de la App",
    family_bible_time: "Tiempo Bíblico en Familia",
    click_to_watch_song: "¡Haz clic en cualquier canción para ver y cantar en YouTube!",
    songs_open_youtube: "¡Las canciones se abren en YouTube para cantar juntos!",
    watch: "Ver",

    // Misc
    show_less: "Ver menos",
    read_more: "Leer más",
    word_hunt: "¡Busca las Palabras!",
    word_hunt_desc: "Estas palabras son de la lección de hoy. ¡Márcalas cuando las encuentres en la historia!",
    all_words_found: "¡Encontraste todas las palabras! ¡Excelente trabajo!",
    think_and_write: "Piensa y Escribe",
    write_thoughts: "Escribe tus pensamientos aquí...",
    correct: "Correcto",
    not_answered: "Sin respuesta",
    notes_from_parents: "Notas de Mamá y Papá",
    allow_notifications: "Por favor permite las notificaciones en la configuración de tu navegador.",
    could_not_enable_notifications: "No se pudieron habilitar las notificaciones.",
    share_bible_buds_title: "Bible Buds - Lecciones Bíblicas Diarias para Niños",
    share_bible_buds_text: "¡Descubre Bible Buds! Lecciones bíblicas diarias, actividades divertidas y tiempo de estudio familiar para niños de 3-18 años.",
    encouragement: "Ánimo",
    parent: "Padre",
    cancel_subscription_message: "Para cancelar tu suscripción, por favor contáctanos en",
    cancel_subscription_provide_email: "y proporciona el correo usado para iniciar sesión en biblebuds.space.",
    
    // Additional translations
    reading: "Leyendo...",
    practice: "Practicar",
    saving: "Guardando...",
    saved: "¡Guardado!",
    overview: "Resumen",
    childrens_lessons: "Lecciones de los Niños",
    family_activity: "Actividad Familiar",
    prayer_focus: "Enfoque de Oración",
    family_notes_label: "Notas Familiares",
    completed: "Completado",
    day_streak: "días seguidos",
    family_bible_study: "Estudio Bíblico Familiar",
    analytics_overview: "Resumen de Analíticas",
    weekly_summary: "Resumen Semanal",
    monthly_progress: "Progreso Mensual",
    total_family_lessons: "Total de Lecciones Familiares",
    total_family_stars: "Total de Estrellas Familiares",
    avg_completion_rate: "Tasa Promedio de Finalización",
    most_active_child: "Niño Más Activo",
    contact_support: "Contactar Soporte",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
